import randomNumberForToday from '../../../../common/utils/randomNumberForToday'

const data: any = [
  {
    id: 23714045,
    name: 'Ekko - Multi-Purpose WordPress Theme with Page Builder',
    description:
      '\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nEkko – WordPress Theme with Page Builder by KeyDesign Themes\nEkko offers an exciting and stylish design – perfect for a business with a modern outlook. Establishing a good first impression with your users is crucial for your business website. Ekko provides a solid selection of useful options, over 50 demos built with your specific industry or niche in mind and is powerful enough to assist any small businesses or corporate companies. The bundled WPBakery Page Builder gives you greater design flexibility and allows to create your own layouts. You can also use over 200 pre-populated template designs and easily swap in your own images and content without having to touch a single line of code. You can now focus your time and',
    site: 'themeforest.net',
    classification: 'wordpress/corporate/business',
    price_cents: 5900,
    number_of_sales: 2660,
    author_username: 'Key-Design',
    author_url: 'https://themeforest.net/user/Key-Design',
    url:
      'https://themeforest.net/item/ekko-multipurpose-wordpress-theme-with-page-builder/23714045',
    summary:
      'Gutenberg Optimized: No, High Resolution: Yes, Widget Ready: Yes, Compatible Browsers: IE11, Firefox, Safari, Opera, Chrome, Edge, Compatible With: bbPress 2.5.x, bbPress 2.4.x, Events Calendar, Events Calendar Pro, Events Calendar Pro 3.x, Gravity Forms, Gravity Forms 1.9.x, Gravity Forms 1.8.x, Visual Composer 5.1.x, WooCommerce 4.0.x, WooCommerce 3.9.x, WooCommerce 3.8.x, WooCommerce 3.7.x, WPBakery Page Builder 6.1.x, WPBakery Page Builder 6.0.x, WPBakery Page Builder 5.7.x, WPBakery Page Builder 5.6.x, WPML, Bootstrap 3.x, Software Version: WordPress 5.4.x, WordPress 5.3.x, WordPress 5.2.x, WordPress 5.1.x, WordPress 5.0.x, Columns: 4+',
    rating: { rating: 4.88, count: 56 },
    updated_at: '2020-05-21T02:59:38+10:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/264030646/thumbnail.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/268162873/01_preview.__large_preview.jpg'
      },
      live_site: {
        url:
          'https://themeforest.net/item/ekko-multipurpose-wordpress-theme-with-page-builder/full_screen_preview/23714045'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/268162873/01_preview.__large_preview.jpg',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/268162873/01_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=18ced90175db377e5e9bdebc3eb552de',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: '4+' },
      {
        name: 'compatible-browsers',
        value: ['IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'bbPress 2.5.x',
          'bbPress 2.4.x',
          'Events Calendar',
          'Events Calendar Pro',
          'Events Calendar Pro 3.x',
          'Gravity Forms',
          'Gravity Forms 1.9.x',
          'Gravity Forms 1.8.x',
          'Visual Composer 5.1.x',
          'WooCommerce 4.0.x',
          'WooCommerce 3.9.x',
          'WooCommerce 3.8.x',
          'WooCommerce 3.7.x',
          'WPBakery Page Builder 6.1.x',
          'WPBakery Page Builder 6.0.x',
          'WPBakery Page Builder 5.7.x',
          'WPBakery Page Builder 5.6.x',
          'WPML',
          'Bootstrap 3.x'
        ]
      },
      { name: 'demo-url', value: 'https://www.ekko-wp.com/' },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'framework', value: null },
      { name: 'gutenberg-optimized', value: 'No' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'CSS Files', 'JS Files']
      },
      { name: 'widget-ready', value: 'Yes' }
    ],
    key_features: [
      'Live Page Editor with Block Builder',
      '50 Premade Full Websites',
      'Easy Setup, Customize - No Coding Required'
    ],
    image_urls: [],
    tags: [
      'auto service',
      'beauty salon',
      'catering',
      'home decor',
      'lawyer',
      'makeup artist',
      'moving company',
      'pizza',
      'renewable energy',
      'seo agency',
      'seo friendly',
      'vet',
      'web design agency',
      'wedding planner',
      'workshop'
    ],
    discounts: []
  },
  {
    id: 25193838,
    name: 'Ohio - Creative Portfolio & Agency WordPress Theme',
    description:
      '\n\n\n\n\n\n\n\n\n\n\n\n    Ohio – is a carefully crafted multi-purpose, minimalist, gorgeous, versatile portfolio and creative showcase theme with sharp user experience you need to building a modern and functional website, and start selling your products and services. It comes with the most popular WordPress page builder WPBakery Page Builder (formerly Visual Composer) plugin and ACF Pro for theme settings. Create slick, modern and fast WooCommerce, shop, portfolio, blog website fast and without coding.\n\n\n    Ohio has professional, pixel perfect and clean modern layouts for almost any website need:    \n\n\n    Food, Adventure Blogger WordPress Theme;\n    Digital, Creative, Corporate agency WordPress Theme;\n    Clean, Minimal and Outstanding Creative Por',
    site: 'themeforest.net',
    classification: 'wordpress/creative/portfolio',
    price_cents: 5900,
    number_of_sales: 2503,
    author_username: 'colabrio',
    author_url: 'https://themeforest.net/user/colabrio',
    url: 'https://themeforest.net/item/ohio-creative-wordpress-theme/25193838',
    summary:
      'Gutenberg Optimized: Yes, High Resolution: Yes, Widget Ready: Yes, Compatible Browsers: IE10, IE11, Firefox, Safari, Opera, Chrome, Edge, Compatible With: WooCommerce 4.0.x, WooCommerce 3.9.x, WooCommerce 3.8.x, WooCommerce 3.7.x, WPBakery Page Builder 6.1.x, WPBakery Page Builder 6.0.x, WPBakery Page Builder 5.7.x, Software Version: WordPress 5.4.x, WordPress 5.3.x, WordPress 5.2.x, WordPress 5.1.x, WordPress 5.0.x, Columns: 4+',
    rating: { rating: 4.94, count: 68 },
    updated_at: '2020-05-07T22:02:16+10:00',
    trending: true,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/288628484/thumbnail__80x80__v1.1.0.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/288628485/01_preview_590x300.__large_preview.jpg'
      },
      live_site: {
        url:
          'https://themeforest.net/item/ohio-creative-wordpress-theme/full_screen_preview/25193838'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/288628485/01_preview_590x300.__large_preview.jpg',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/288628485/01_preview_590x300.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=b65e0a6abb7eb49130b62203e18b1362',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: '4+' },
      {
        name: 'compatible-browsers',
        value: ['IE10', 'IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'WooCommerce 4.0.x',
          'WooCommerce 3.9.x',
          'WooCommerce 3.8.x',
          'WooCommerce 3.7.x',
          'WPBakery Page Builder 6.1.x',
          'WPBakery Page Builder 6.0.x',
          'WPBakery Page Builder 5.7.x'
        ]
      },
      { name: 'demo-url', value: 'https://ohio.clbthemes.com/' },
      { name: 'documentation', value: 'Unrated' },
      { name: 'framework', value: null },
      { name: 'gutenberg-optimized', value: 'Yes' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'CSS Files', 'Sass Files', 'JS Files']
      },
      { name: 'widget-ready', value: 'Yes' }
    ],
    key_features: [
      'Clean, Minimal & Creative Portfolio Layouts',
      'Modern Digital & Creative Agency',
      'WPBakery, ACF Pro and Slider Revolution'
    ],
    image_urls: [],
    tags: [
      'agency',
      'blog',
      'business',
      'clean',
      'corporate',
      'creative',
      'event',
      'minimal',
      'modern',
      'multipurpose',
      'photography',
      'portfolio',
      'responsive',
      'shop',
      'showcase'
    ],
    discounts: []
  },
  {
    id: 24689900,
    name: 'Pixwell - Modern Magazine',
    description:
      '\n\n\n\n\n\n\n\n\n\nPixwell is a powerful, multipurpose and modern WordPress magazine theme with pixel perfect design, outstanding features, fully responsive and mobile-friendly. It is a very flexible and well suited for recipe, fashion, travel, technology, personal or any other awesome magazine and blog websites.\nThe theme is compatible and optimized to work with Elementor, Cooked (Recipe plugin), WooCommerce, Contact Form 7, AMP, W3 Total Cache, Yoast SEO, and many other popular WordPress plugins.\nPixwell is SEO friendly with Schema compatible structure. Supports organization, site links search box, breadcrumbs bar, open graph. That will make search engines love your website.\nPixwell is also optimized for the database and fast load. Pixwell is buil',
    site: 'themeforest.net',
    classification: 'wordpress/blog-magazine/news-editorial',
    price_cents: 2900,
    number_of_sales: 1821,
    author_username: 'Theme-Ruby',
    author_url: 'https://themeforest.net/user/Theme-Ruby',
    url: 'https://themeforest.net/item/pixwell-modern-magazine/24689900',
    summary:
      'Gutenberg Optimized: Yes, High Resolution: Yes, Widget Ready: Yes, Compatible Browsers: IE11, Firefox, Safari, Opera, Chrome, Edge, Compatible With: Elementor, WooCommerce 4.0.x, WooCommerce 3.9.x, WooCommerce 3.8.x, Software Version: WordPress 5.4.x, WordPress 5.3.x, WordPress 5.2.x, WordPress 5.1.x, WordPress 5.0.x, Columns: 4+',
    rating: { rating: 4.97, count: 71 },
    updated_at: '2020-05-11T16:45:54+10:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/272097380/icon.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/281568389/01_preview.__large_preview.jpg'
      },
      live_site: {
        url:
          'https://themeforest.net/item/pixwell-modern-magazine/full_screen_preview/24689900'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/281568389/01_preview.__large_preview.jpg',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/281568389/01_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=dc9e330cf91b40481627358d8afbe4bf',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/281568389/02_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=de3b14d985d40d482dc200b9ec78fcae',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/281568389/03_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=3b22727b68d5d99c3a8ed7101f8df1c9',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/281568389/04_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=f6ed91a94bcfa1d93bfab6edffb7246d',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/281568389/05_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=78f9ad771e94d674b1cdaec612f94f62',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: '4+' },
      {
        name: 'compatible-browsers',
        value: ['IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'Elementor',
          'WooCommerce 4.0.x',
          'WooCommerce 3.9.x',
          'WooCommerce 3.8.x'
        ]
      },
      { name: 'demo-url', value: 'https://tf01.themeruby.com/' },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'framework', value: null },
      { name: 'gutenberg-optimized', value: 'Yes' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'CSS Files', 'JS Files']
      },
      { name: 'widget-ready', value: 'Yes' }
    ],
    key_features: [
      'Suitable for News, Magazine and Blog Website',
      'Minimalist, Clean and Responsive Design',
      'Gutenberg, Elementor and extra SEO Support'
    ],
    image_urls: [],
    tags: [
      'blog',
      'blogger',
      'clean',
      'creative',
      'fashion',
      'food',
      'lifestyle',
      'magazine',
      'minimal',
      'modern',
      'news',
      'personal',
      'responsive',
      'simple',
      'travel'
    ],
    discounts: []
  },
  {
    id: 24207799,
    name: 'Jumpstart App and Software Template',
    description:
      '\nBased completely on Bootstrap HTML and CSS, Jumpstart is the perfect template choice when starting your next Saas, app or software website. Jumpstart’s multipurpose landing page pack comes complete with a full HTML UI kit to round out your online presence, from help center pages, to responsive blog listings and everything in between.\n\n\n\nJumpstart includes a variety of landing pages to sell your software, app or online SaaS, backed up by working contact forms and Mail Chimp subscribe forms (with reCAPTCHA), interactive and customizable maps, scroll animations, counters, sliders, galleries, video backgrounds and more!\n\n\n\nPackaged as a complete design system, there is no limit to the number of layouts you can create.  Using Jumpstart’s indivi',
    site: 'themeforest.net',
    classification: 'site-templates/technology',
    price_cents: 1800,
    number_of_sales: 1647,
    author_username: 'medium_rare',
    author_url: 'https://themeforest.net/user/medium_rare',
    url:
      'https://themeforest.net/item/jumpstart-app-and-software-template/24207799',
    summary:
      'High Resolution: Yes, Compatible Browsers: IE11, Firefox, Safari, Opera, Chrome, Edge, Compatible With: Bootstrap 4.x, Columns: 4+',
    rating: { rating: 4.93, count: 29 },
    updated_at: '2020-02-26T11:58:24+11:00',
    trending: true,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/281993115/thumbnail.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/281993116/item-preview-image-normal.__large_preview.jpg'
      },
      live_site: {
        url:
          'https://themeforest.net/item/jumpstart-app-and-software-template/full_screen_preview/24207799'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/281993116/item-preview-image-normal.__large_preview.jpg',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/281993116/item-preview-image-normal.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=d4d381d0c1529d66df08d946d53ffd7d',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: '4+' },
      {
        name: 'compatible-browsers',
        value: ['IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      { name: 'compatible-with', value: ['Bootstrap 4.x'] },
      { name: 'demo-url', value: 'https://jumpstart.mediumra.re/' },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'HTML Files', 'CSS Files', 'JS Files']
      }
    ],
    key_features: [
      'Perfect for SaaS, App and Software sites',
      'Responsive Bootstrap landing pages + UI Kit',
      'Work using static files or run Gulp tooling'
    ],
    image_urls: [],
    tags: [
      'agency',
      'app',
      'bootstrap',
      'business',
      'corporate',
      'hosting',
      'landing',
      'marketing',
      'mobile',
      'multipurpose',
      'saas',
      'sass',
      'software',
      'startup',
      'ui kit'
    ],
    discounts: []
  },
  {
    id: 25582188,
    name: 'Cork - Responsive Admin Dashboard Template',
    description:
      '\n\n\n\n\n\t\n\n\n\n\n\t\n\n\n\n\n\t\n\n\n\n\n\tCork is a powerful admin dashboard template based on Bootstrap and Sass for all kind of back-end projects. It comes with bunch of working JavaScript apps to build your next back-end application with ease.\n\n\n\tOur Admin theme contains collection of well-designed demos that will save you a lot of time and effort by not having to start from scratch. Cork Admin also comes with multitude of reusable components such as buttons, maps, charts, widgets, forms, tables and bunch of elements that you can include in your project. The design is responsive and is 100% adapted to mobile devices of all sizes.\n\n\n\tWith its applications, components and pages included – Cork Admin template is an excellent starting point for your next proj',
    site: 'themeforest.net',
    classification: 'site-templates/admin-templates',
    price_cents: 800,
    number_of_sales: 1646,
    author_username: 'designreset',
    author_url: 'https://themeforest.net/user/designreset',
    url:
      'https://themeforest.net/item/cork-responsive-admin-dashboard-template/25582188',
    summary:
      'High Resolution: Yes, Compatible Browsers: IE11, Firefox, Safari, Opera, Chrome, Edge, Compatible With: Bootstrap 4.x, Columns: 4+',
    rating: { rating: 4.88, count: 42 },
    updated_at: '2020-05-20T02:44:36+10:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/279918979/logo.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/290008541/01_preview.__large_preview.png'
      },
      live_site: {
        url:
          'https://themeforest.net/item/cork-responsive-admin-dashboard-template/full_screen_preview/25582188'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/290008541/01_preview.__large_preview.png',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/290008541/01_preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=67335bd523edd1c1f61dd2c1e8f8753f',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: '4+' },
      {
        name: 'compatible-browsers',
        value: ['IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      { name: 'compatible-with', value: ['Bootstrap 4.x'] },
      { name: 'demo-url', value: 'https://designreset.com/cork-admin/' },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      {
        name: 'themeforest-files-included',
        value: ['HTML Files', 'CSS Files', 'Sass Files', 'JS Files']
      }
    ],
    key_features: [
      'Bootstrap 4.5.x + Sass and Gulp task runner',
      'Admin Template with RTL and LTR Layouts',
      'Dark and Light versions'
    ],
    image_urls: [],
    tags: [
      'admin',
      'admin dashboard',
      'admin template',
      'admin themes',
      'analytics',
      'bootstrap',
      'bootstrap 4',
      'bootstrap 4 admin template',
      'premium admin templates',
      'responsive',
      'responsive admin dashboard',
      'sales dashboard',
      'sass',
      'ui kit',
      'web app'
    ],
    discounts: []
  },
  {
    id: 23850621,
    name: 'Webify – All-in-One Elementor WordPress Theme',
    description:
      '  \n\n\tWebify = Multi-purpose demos + Modular elements &amp; custom cache system (i.e. only loads elements that are used, 2.4x faster) + Live page builder &amp; customizer + GDPR Compliant + WPML (translation ready) + RTL (Arabic, Hebrew, etc.) + 100% Responsive + WooCommerce + Gutenberg Optimized + SEO friendly (rank faster on Google) + 160+ Elements &amp; Modules + Unlimited Layouts + Lifetime free updates.    \n         \n         \n\n\n\n\n\n\n    \n\n\n\n\n\n\n\tWebify is a clean, super flexible and fully responsive WordPress Theme (try resizing your browser), suited for business websites and users who want to showcase their work on a neat portfolio site.\n\n\n\tIt comes with a plethora of options so you can modify layout, styling, colors and fonts directly ',
    site: 'themeforest.net',
    classification: 'wordpress/corporate/business',
    price_cents: 5900,
    number_of_sales: 1411,
    author_username: 'theme_bubble',
    author_url: 'https://themeforest.net/user/theme_bubble',
    url:
      'https://themeforest.net/item/webify-allinone-responsive-wordpress-theme/23850621',
    summary:
      'Gutenberg Optimized: Yes, High Resolution: Yes, Widget Ready: Yes, Compatible Browsers: IE10, IE11, Firefox, Safari, Opera, Chrome, Compatible With: Easy Digital Downloads, Easy Digital Downloads 2.8.x, Easy Digital Downloads 2.7.x, Easy Digital Downloads 2.6.x, Easy Digital Downloads 2.5.x, Elementor, Gravity Forms, Gravity Forms 1.9.x, WooCommerce 3.6.x, WooCommerce 3.5.x, WooCommerce 3.4.x, WooCommerce 3.3.x, WPML, Bootstrap 2.2.1, Bootstrap 2.1.1, Bootstrap 2.1.0, Software Version: WordPress 5.4.x, WordPress 5.3.x, WordPress 5.2.x, WordPress 5.1.x, WordPress 5.0.x, WordPress 4.9.x, WordPress 4.8.x, WordPress 4.7.x, WordPress 4.6.1, Columns: 4+',
    rating: { rating: 4.93, count: 46 },
    updated_at: '2020-05-01T01:58:41+10:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/265161050/thumb.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/267442981/preview.__large_preview.png'
      },
      live_site: {
        url:
          'https://themeforest.net/item/webify-allinone-responsive-wordpress-theme/full_screen_preview/23850621'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/267442981/preview.__large_preview.png',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/267442981/preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=e842126eb5c46922c4d67393b7016923',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: '4+' },
      {
        name: 'compatible-browsers',
        value: ['IE10', 'IE11', 'Firefox', 'Safari', 'Opera', 'Chrome']
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x',
          'WordPress 4.9.x',
          'WordPress 4.8.x',
          'WordPress 4.7.x',
          'WordPress 4.6.1'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'Easy Digital Downloads',
          'Easy Digital Downloads 2.8.x',
          'Easy Digital Downloads 2.7.x',
          'Easy Digital Downloads 2.6.x',
          'Easy Digital Downloads 2.5.x',
          'Elementor',
          'Gravity Forms',
          'Gravity Forms 1.9.x',
          'WooCommerce 3.6.x',
          'WooCommerce 3.5.x',
          'WooCommerce 3.4.x',
          'WooCommerce 3.3.x',
          'WPML',
          'Bootstrap 2.2.1',
          'Bootstrap 2.1.1',
          'Bootstrap 2.1.0'
        ]
      },
      { name: 'demo-url', value: 'http://themebubble.com/demo/webify/' },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'framework', value: null },
      { name: 'gutenberg-optimized', value: 'Yes' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      {
        name: 'themeforest-files-included',
        value: ['Layered PNG', 'PHP Files', 'CSS Files', 'JS Files']
      },
      { name: 'widget-ready', value: 'Yes' }
    ],
    key_features: [
      '46+ Plus Stunning Demos',
      'Fast & Super Flexible',
      'Excellent Customer Support'
    ],
    image_urls: [],
    tags: [
      'agency',
      'business',
      'corporate',
      'creative',
      'custom layout',
      'customizable',
      'elementor',
      'marketing',
      'mobile',
      'modern',
      'photography',
      'portfolio',
      'responsive',
      'seo',
      'wpml'
    ],
    discounts: []
  },
  {
    id: 24304706,
    name: 'Newspaper News Magazine WordPress Theme - Digiqole',
    description:
      'Digiqole is a Simple, Easy to Use WordPress Theme for Newsportal, Magazine site, Small Company, and Business News. This amazing News Magazine theme built with Bootstrap4 framework, Elementor Builder, Unique home variations for a perfect News Magazine Website. \n\n\nDigiqole also comes with 20+ News Blocks such as News Tab, News Slider, News List, News Video block, News Carousel etc. Also, we have support for RTL News and RTL Magazine Site. You will get Dark Mode and eye-catching home variation to get the best feel of a News/Magazine Website.\n\n\n\nCURRENT VERSION 1.2.5 (See Change log at the bottom of this page)\n\n\n\n\n\nTheme Features\n\n   Full demo with One Click Installation \nLogo Image and Logo Text Option\n   Elementor Page Builder\nRTL Language Su',
    site: 'themeforest.net',
    classification: 'wordpress/blog-magazine/news-editorial',
    price_cents: 3500,
    number_of_sales: 1393,
    author_username: 'trippleS',
    author_url: 'https://themeforest.net/user/trippleS',
    url:
      'https://themeforest.net/item/digiqole-news-magazine-wordpress-theme/24304706',
    summary:
      'Gutenberg Optimized: Yes, High Resolution: Yes, Widget Ready: Yes, Compatible Browsers: IE9, IE10, IE11, Firefox, Safari, Opera, Chrome, Edge, Compatible With: Elementor, WooCommerce 3.8.x, WooCommerce 3.7.x, WooCommerce 3.6.x, WooCommerce 3.5.x, WooCommerce 3.4.x, WooCommerce 3.3.x, WooCommerce 3.2.x, WooCommerce 3.1.x, Bootstrap 4.x, Framework: Unyson, Software Version: WordPress 5.4.x, WordPress 5.3.x, WordPress 5.2.x, WordPress 5.1.x, WordPress 5.0.x, Columns: 3',
    rating: { rating: 4.85, count: 52 },
    updated_at: '2020-05-21T14:31:01+10:00',
    trending: true,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/289683513/thumbnail.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/288549532/theme_preview.__large_preview.png'
      },
      live_site: {
        url:
          'https://themeforest.net/item/digiqole-news-magazine-wordpress-theme/full_screen_preview/24304706'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/288549532/theme_preview.__large_preview.png',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/288549532/theme_preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=480bc7e87ab88147a7acd4ef520588e8',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: '3' },
      {
        name: 'compatible-browsers',
        value: [
          'IE9',
          'IE10',
          'IE11',
          'Firefox',
          'Safari',
          'Opera',
          'Chrome',
          'Edge'
        ]
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'Elementor',
          'WooCommerce 3.8.x',
          'WooCommerce 3.7.x',
          'WooCommerce 3.6.x',
          'WooCommerce 3.5.x',
          'WooCommerce 3.4.x',
          'WooCommerce 3.3.x',
          'WooCommerce 3.2.x',
          'WooCommerce 3.1.x',
          'Bootstrap 4.x'
        ]
      },
      {
        name: 'demo-url',
        value: 'http://demo.themewinter.com/wp/digiqole/landing/'
      },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'framework', value: ['Unyson'] },
      { name: 'gutenberg-optimized', value: 'Yes' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'CSS Files', 'JS Files']
      },
      { name: 'widget-ready', value: 'Yes' }
    ],
    key_features: [
      'Elementor News Magazine Theme',
      'Mega Menu, RTL News and Review',
      'Classic Newspaper, Grid and List Layouts'
    ],
    image_urls: [],
    tags: [
      'blog',
      'editorial',
      'gutenberg',
      'journal',
      'news',
      'news magazine',
      'newspaper',
      'online magazine',
      'online newspaper',
      'Responsive Magazine',
      'responsive news',
      'review',
      'travel'
    ],
    discounts: []
  },
  {
    id: 24656841,
    name: 'Frest - HTML & Laravel Bootstrap Admin Dashboard Template',
    description:
      '\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nThe most comprehensive bootstrap admin dashboard template of 2019!\n\n   Frest – Clean &amp; Minimal Bootstrap Admin Dashboard Template – is beautifully crafted, clean &amp; minimal designed admin template with Dark / Light Layouts, Animated Icons &amp; RTL options.\n\n\n   Looking for an admin dashboard that was made with you in mind, look no further than Frest Admin. A powerful admin dashboard template built on Bootstrap 4, Frest is developer-friendly, rich with features and highly customizable. We’ve followed the highest industry standards to bring you the very best admin template that is not only fast and easy to use but highly scalable.\n\n\nBuild premium quality applications ',
    site: 'themeforest.net',
    classification: 'site-templates/admin-templates',
    price_cents: 2400,
    number_of_sales: 1329,
    author_username: 'PIXINVENT',
    author_url: 'https://themeforest.net/user/PIXINVENT',
    url:
      'https://themeforest.net/item/frest-clean-minimal-bootstrap-admin-dashboard-template/24656841',
    summary:
      'High Resolution: Yes, Compatible Browsers: Firefox, Safari, Opera, Chrome, Edge, Compatible With: Bootstrap 4.x',
    rating: { rating: 4.96, count: 25 },
    updated_at: '2020-04-04T00:08:08+11:00',
    trending: true,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/281739522/thumbnail.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/281739525/preview-image/01.__large_preview.jpg'
      },
      live_site: {
        url:
          'https://themeforest.net/item/frest-clean-minimal-bootstrap-admin-dashboard-template/full_screen_preview/24656841'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/281739525/preview-image/01.__large_preview.jpg',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/281739525/preview-image/01.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=9747d659981bdbbb51a69db1fdcdb4df',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/281739525/preview-image/02.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=7333b3b37d467d58386ff4b62e30a914',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/281739525/preview-image/03.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=ebf97a7cdd1416a5f32a6a4d8f6aca12',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/281739525/preview-image/04.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=1f0f378a0248a1715007494c364b6bbc',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/281739525/preview-image/05.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=afbbcabaa8fa771cbc5ee7b022d7aa98',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: null },
      {
        name: 'compatible-browsers',
        value: ['Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      { name: 'compatible-with', value: ['Bootstrap 4.x'] },
      {
        name: 'demo-url',
        value:
          'https://pixinvent.com/demo/frest-clean-bootstrap-admin-dashboard-template/landing-page/'
      },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'HTML Files', 'CSS Files', 'JS Files']
      }
    ],
    key_features: [
      '6 Layouts - 2 Dashboards - Laravel Bootstrap',
      'Responsive Bootstrap 4 - SCSS -  RTL Suport',
      '7 Workable apps - Dark-Light Layouts'
    ],
    image_urls: [],
    tags: [
      'admin',
      'admin dashboard',
      'bootstrap',
      'bootstrap 4',
      'bootstrap dashboard',
      'clean',
      'crm',
      'dashboard',
      'laravel',
      'laravel admin',
      'Laravel Dashboard',
      'minimal',
      'modern',
      'responsive',
      'ui'
    ],
    discounts: []
  }
]

const NUM_ITEMS = 4

export default () => {
  const start = randomNumberForToday(0, data.length / NUM_ITEMS) * NUM_ITEMS
  const end = start + NUM_ITEMS
  return {
    data: data.slice(start, end),
    title: 'More time to focus on what you do best',
    tiles: [
      {
        title: 'Save time',
        description: 'Save time with customisable templates',
        icon: 'time'
      },
      {
        title: 'Save money',
        description: 'Save money with affordable templates',
        icon: 'money'
      },
      {
        title: 'Be unique',
        description: 'Easily find niche and unique themes',
        icon: 'uniq'
      }
    ]
  }
}
